<template>

</template>

<script>
export default {
  name: "WordAndPhaseBlacklistingPage"
}
</script>


